export const BASE_URL = 'https://ais-backend-server.herokuapp.com';
// export const BASE_URL = 'http://localhost:9000';
